/**
 * Returns a sorting function that gives priority to selected values and then sorts on additional properties
 * @param selected Array of selected values
 * @param prop Matching property to check for in selected array
 * @param fallback Optional fallback property or sorting function
 */
export const sortSelectedName =
  <T extends object>(
    selected: Array<string>,
    prop: keyof T,
    fallback?: keyof T | ((a: T, b: T) => number),
  ) =>
  (a: T, b: T) => {
    if (selected?.includes(`${a[prop]}`) && !selected.includes(`${b[prop]}`))
      return -1;
    if (selected?.includes(`${b[prop]}`) && !selected.includes(`${a[prop]}`))
      return 1;
    // If we don't have a fallback don't change order
    if (!fallback) return 0;
    if (typeof fallback === 'function') return fallback(a, b);
    return a[fallback] > b[fallback] ? 1 : -1;
  };
